import type { OssUploadSettings } from 'fin-web-components';

/**
 * OSS 对象键（完整路径）命名规则（由 fin-web-components 的 uploadFileToOss 生成）：
 *   {目录}/{文件名}
 * 其中：
 *   - 目录：见下方 APP_OSS_UPLOAD_PATHS 各场景配置
 *   - 文件名：category_{毫秒时间戳}.{扩展名}，扩展名取自原文件后缀，缺省 jpg
 * 示例：app/companion/chat/image/category_1718000000123.png
 */
export const APP_OSS_OBJECT_KEY_RULE =
  '{scenePath}/category_{timestampMs}.{originalExtension|jpg}';

/** 用户端 OSS 连接信息（非敏感；AccessKey 由后端临时签发） */
export const APP_OSS_UPLOAD_CONFIG: OssUploadSettings = {
  region: 'oss-cn-shanghai',
  bucket: 'lark-resource',
  endpoint: 'https://oss-cn-shanghai.aliyuncs.com',
};

/** 按业务场景划分的上传目录（objectKey 前缀，不含文件名） */
export const APP_OSS_UPLOAD_PATHS = {
  /** 用户头像 */
  USER_AVATAR: 'app/user/avatar',
  /** 盘中陪伴聊天室 · 图片消息 */
  COMPANION_CHAT_IMAGE: 'app/companion/chat/image',
} as const;

export type AppOssUploadScene = keyof typeof APP_OSS_UPLOAD_PATHS;

export function getAppOssUploadPath(scene: AppOssUploadScene): string {
  return APP_OSS_UPLOAD_PATHS[scene];
}
